/* eslint-disable react/prop-types */
import React, { useState, useEffect, Fragment } from "react";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { AccessType } from "@quintype/components";
import assetify from "@quintype/framework/assetify";
import PaywallImage from "../../../../../assets/images/nl-hill-sub.png";
import logo from "../../../../../assets/images/newslaundry_logo.png";
import Loader from "../../../atoms/loader";
import { benefits, GROUPS } from "./constants";
import "./paywall.m.css";
import { getAuthUrl } from "../../../helper/hooks";
import IntegrationData from "../../../../../../config/integrations.js";
// import { getMaxListeners } from "superagent";

export const Paywall = props => {
  const [selectedGroup, setSelectedGroup] = useState(GROUPS[1]); // by default game changer
  const [selectedPlan, setSelectedPlan] = useState(selectedGroup.plans[2]); // by default annual
  const [paymentOption, setPaymentOption] = useState("razorpay"); // by default razorpay
  const [isIndian, setIsIndian] = useState(true);

  const hasActiveSubscription = useSelector(state =>
    get(state, ["fetchSubscription", "isActive"], null)
  );

  const { fetchSubscription } = useSelector(state => state);

  const expiredUser = useSelector(state => {
    return get(state, ["fetchSubscription", "isExpired"], null);
  });

  const member = useSelector(state => {
    return get(state, ["member"], null);
  });

  const pushToDataLayer = (event, url, action) => {
    const obj = {
      event: event,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    if (url) {
      obj.paywall_content_name = url;
    }

    if (action) {
      obj.paywall_user_action = action;
    }

    window.dataLayer.push(obj);
  };

  useEffect(() => {
    pushToDataLayer("story_paywall", props.url, null);
  }, []);

  useEffect(() => {
    setSelectedPlan(selectedGroup.plans[2]);

    // set paywall with trial plan if first time user
    if (expiredUser === false) {
      setSelectedGroup(GROUPS[0]);
      setSelectedPlan(GROUPS[0].trialPlans[0]);
      if (!isIndian) {
        setPaymentOption("stripe");
      }
    }
  }, [selectedGroup, expiredUser, isIndian]);

  return (
    <Fragment>
      <div styleName="cta">
        <img src={assetify(logo)} alt="subscription image" styleName="logo" />
        <h2 styleName="paywall-title">
          {expiredUser
            ? "Subscribe now to unlock the story!"
            : "Continue reading this story for free"}
        </h2>
        <br />
      </div>

      <div styleName="wrapper">
        <div styleName={expiredUser ? "head-wrapper" : "head-trial-wrapper"}>
          <img src={assetify(PaywallImage)} />
          <h2 styleName="title">Why should I pay for news?</h2>
          <p styleName="description">
            Independent journalism is not possible until you pitch in. We have
            seen what happens in ad-funded models: Journalism takes a backseat
            and gets sacrificed at the altar of clicks and TRPs. <br />
            <br />
            Stories like these these cost perseverance, time, and resources.
            Subscribe now to power our journalism.
          </p>
        </div>
        <br />
        <div styleName="body-wrapper">
          <Benefits
            selectedGroup={selectedGroup}
            setSelectedGroup={setSelectedGroup}
            expiredUser={expiredUser}
          />

          {!expiredUser && (
            <label styleName="india-check">
              <input
                type="checkbox"
                defaultChecked={isIndian}
                onChange={() => setIsIndian(!isIndian)}
              />
              I am based in India. Uncheck if you&apos;re overseas.
            </label>
          )}

          {expiredUser && (
            <Plans
              selectedPlan={selectedPlan}
              setSelectedPlan={setSelectedPlan}
              selectedGroup={selectedGroup}
              setSelectedGroup={setSelectedGroup}
            />
          )}

          {expiredUser && (
            <PaymentMethods
              paymentOption={paymentOption}
              setPaymentOption={setPaymentOption}
              expiredUser={expiredUser}
            />
          )}
          <Subscribe
            member={member}
            hasActiveSubscription={hasActiveSubscription}
            selectedGroup={selectedGroup}
            selectedPlan={selectedPlan}
            paymentOption={paymentOption}
            expiredUser={expiredUser}
            url={props.url}
          />
        </div>
      </div>
    </Fragment>
  );
};

const Benefits = props => {
  return (
    <div styleName="benefits-wrapper">
      <div styleName="tab">
        <button
          styleName={`${
            props.selectedGroup.name === "Disruptor" ? "tab-btn-active" : ""
          } tab-btn `}
          onClick={() => props.setSelectedGroup(GROUPS[0])}
        >
          Disruptor
        </button>
        {props.expiredUser && (
          <button
            styleName={`${
              props.selectedGroup.name === "Game Changer"
                ? "tab-btn-active"
                : ""
            } tab-btn `}
            onClick={() => props.setSelectedGroup(GROUPS[1])}
          >
            Game Changer
          </button>
        )}
      </div>

      <ul styleName="benefits">
        {benefits.map((benefit, index) => {
          return (
            <li
              styleName={
                props.selectedGroup.name === "Disruptor" &&
                (+index === 4 || +index === 5)
                  ? "invalid-benefit"
                  : "valid-benefit"
              }
              key={index + 1}
            >
              {benefit}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const Plans = props => {
  // handle discounted price

  return (
    <div styleName="plan-wrapper">
      {props.selectedGroup.plans.map((plan, index) => {
        return (
          <Fragment key={index}>
            <div
              styleName={
                props.selectedPlan === plan
                  ? "plan-blocks active"
                  : "plan-blocks"
              }
              onClick={() => props.setSelectedPlan(plan)}
            >
              ₹ {plan.price}
              <p>{plan.name}</p>
            </div>
            <p></p>
          </Fragment>
        );
      })}
    </div>
  );
};

const PaymentMethods = props => {
  const [error, setError] = useState(null);

  const handleChange = option => {
    if (option !== "razorpay" && !props.expiredUser) {
      setError("Oops! This is not recommended for users based in India");
    } else {
      setError("");
    }

    props.setPaymentOption(option);
  };

  return (
    <div styleName="payment-methods-wrapper">
      <div onClick={() => handleChange("stripe")} styleName="method">
        <input type="radio" checked={props.paymentOption === "stripe"} />
        <label>Credit/Debit Card</label>
      </div>

      <div onClick={() => handleChange("razorpay")} styleName="method">
        <input type="radio" checked={props.paymentOption === "razorpay"} />
        <label>UPI{props.expiredUser && ", Netbanking, Rupay"}</label>
      </div>

      <div onClick={() => handleChange("paypal")} styleName="method">
        <input type="radio" checked={props.paymentOption === "paypal"} />
        <label>Paypal</label>
      </div>

      {error && <small>{error}</small>}
    </div>
  );
};

const Subscribe = props => {
  const authUrl = getAuthUrl();

  const { fetchSubscription, member } = useSelector(state => state);

  const allSubscriptions = useSelector(state =>
    get(state, ["subscriptions"], [])
  );
  const groupDetails =
    allSubscriptions &&
    allSubscriptions.find(item => item.id === props.selectedGroup.id);

  const planDetails =
    groupDetails &&
    groupDetails.subscription_plans &&
    groupDetails.subscription_plans.find(
      plan => plan.id === props.selectedPlan.id
    );

  const splitDescription =
    (planDetails &&
      planDetails.description &&
      planDetails.description.split(",")) ||
    "";

  // function to get USD planDetails for paypal payment method
  const getUsdPlan =
    groupDetails &&
    groupDetails.subscription_plans.find(
      plan => plan.id === +splitDescription[1]
    );

  // function to select Equivalent One time plan for razorpay
  const selectEquivalentOneTimePlan = () => {
    const splitDescription =
      (planDetails.description && planDetails.description.split(",")) || "";

    const getSelectedPlan = groupDetails.subscription_plans.filter(
      plan => plan.id === +splitDescription[0]
    );

    return getSelectedPlan[0];
  };

  const redirectURL = global.location;
  const appendSuccessURL =
    planDetails &&
    `?subscription-status=success` +
      ((planDetails.duration_unit === "years" &&
        planDetails.subscription_group_id === 113) ||
      planDetails.subscription_group_id === 760 ||
      planDetails.subscription_group_id === 804 ||
      planDetails.subscription_group_id === 805
        ? "&gamechanger=true"
        : "") +
      ((planDetails.duration_unit === "years" &&
        planDetails.subscription_group_id === 114) ||
      planDetails.subscription_group_id === 759
        ? "&disruptor=true"
        : "");
  const successUrl = redirectURL + appendSuccessURL;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const pushToDataLayer = (event, url, action) => {
    const obj = {
      event: event,
      usertype: member ? "logged in" : "logged out",
      subscribertype: fetchSubscription.isActive
        ? "subscriber"
        : "nonsubscriber",
      userID: member ? member.id : "null",
      subscriptionID: fetchSubscription.isActive
        ? fetchSubscription.items.find(sub => sub.active === true).id
        : "null"
    };

    if (url) {
      obj.paywall_content_name = url;
    }

    if (action) {
      obj.paywall_user_action = action;
    }

    window.dataLayer.push(obj);
  };

  const handlePayment = async (
    initAccessType,
    initRazorPayPayment,
    initStripePayment,
    initPaypalPayment
  ) => {
    setLoading(true);
    pushToDataLayer("story_paywall_user_action", props.url, "subscribe");

    /* Redirect to login if not logged in */
    if (!props.member) {
      window.location = authUrl;
    }

    /* If not active subscriber then Proceed with subscription payment */
    if (props.hasActiveSubscription === false) {
      /* Initiate razorpay */
      if (props.paymentOption === "razorpay") {
        const options = {
          argType: "options",
          selectedPlan: !props.expiredUser
            ? planDetails
            : selectEquivalentOneTimePlan(),
          planType: "standard",
          couponCode: ""
        };

        initRazorPayPayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            await handlePaymentSuccess(res);
          })
          .catch(error => {
            setLoading(false);
            // const getErrorMessage = get(
            //   error,
            //   ["error", "message", "subscriber", 0],
            //   ""
            // );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }

      /*
                Initiate stripe 
            */
      if (props.paymentOption === "stripe") {
        const options = {
          argType: "options",
          selectedPlan: planDetails,
          planType: "standard",
          couponCode: ""
        };

        initStripePayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            res && handlePaymentSuccess(res);
          })
          .catch(error => {
            setLoading(false);
            // const getErrorMessage = get(
            //   error,
            //   ["error", "message", "subscriber", 0],
            //   ""
            // );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }

      /*
                Initiate paypal
            */
      if (props.paymentOption === "paypal") {
        const options = {
          argType: "options",
          selectedPlan: getUsdPlan,
          planType: "standard",
          couponCode: "",
          returnUrl: "https://newslaundry.com",
          cancelUrl: "https://newslaundry.com"
        };

        initPaypalPayment(options)
          .then(async res => {
            // TODO need to store this invoice responce in store for my account
            await handlePaymentSuccess(res);
          })
          .catch(error => {
            setLoading(false);
            // const getErrorMessage = get(
            //   error,
            //   ["error", "message", "subscriber", 0],
            //   ""
            // );
            console.error(`Razorpay error: ${error}`);
            if (error.message === "user closed the payment") {
              setError("User closed the payment.");
            } else {
              setError("Oops! Something went wrong");
            }
          });
      }
    }
  };

  const handlePaymentSuccess = async res => {
    setLoading(false);
    window.location = successUrl;
  };
  const integrationsConfig = IntegrationData();
  const pub = useSelector(state => get(state, ["qt", "config", "publisher"]));
  const email = get(props.member, ["email"], "");
  const phone = get(props.member, ["metadata", "phone"], "");
  const isStaging = get(pub, ["publisher", "accessTypeEnvironment"], true);
  const enableAccesstype = get(
    pub,
    ["publisher", "publisher", "enableAccesstype"],
    true
  );
  const accessTypeKey = isStaging
    ? integrationsConfig.stagingAccessTypeKey
    : integrationsConfig.accessTypeKey;
  const accessTypeBkIntegrationId = isStaging
    ? integrationsConfig.stagingAccessTypeBkIntegrationId
    : integrationsConfig.accessTypeBkIntegrationId;

  return (
    <div styleName="subscribe-wrapper">
      <AccessType
        enableAccesstype={enableAccesstype}
        isAccessTypeCampaignEnabled={true}
        isStaging={false}
        accessTypeKey={accessTypeKey}
        accessTypeBkIntegrationId={accessTypeBkIntegrationId}
        email={email}
        phone={phone}
      >
        {({
          initAccessType,
          initRazorPayPayment,
          initStripePayment,
          initPaypalPayment
        }) => {
          return (
            <Fragment>
              {loading ? (
                <button>
                  <Loader color="white" />
                </button>
              ) : (
                <button
                  onClick={() =>
                    handlePayment(
                      initAccessType,
                      initRazorPayPayment,
                      initStripePayment,
                      initPaypalPayment
                    )
                  }
                >
                  {props.expiredUser ? "Subscribe" : "Start your free trial"}
                  <br />
                  {props.expiredUser && (
                    <small>
                      ₹{props.selectedPlan.price} {props.selectedPlan.name}
                    </small>
                  )}
                </button>
              )}
              {!props.expiredUser && (
                <p>
                  <br /> Post your free trial, you’ll be charged ₹300 per month
                </p>
              )}
              {!props.member && (
                <p>
                  Already a subscriber?{" "}
                  <span>
                    <a
                      onClick={() => {
                        pushToDataLayer(
                          "story_paywall_user_action",
                          props.url,
                          "login"
                        );

                        window.location = authUrl;
                      }}
                    >
                      Login
                    </a>
                  </span>
                </p>
              )}
            </Fragment>
          );
        }}
      </AccessType>
    </div>
  );
};
